import React from 'react'
import styled from 'styled-components'
import TeamContainer from './TeamContainer'

const team = {
    id: 'theGreats',
    members: [
        {
            description: (
                <>
                    Founded Streamr to make data more available, fair, and valuable for all. Built
                    scalable infrastructure & tools for real-time data for 10 years. Passionate
                    about the decentralization of applications and data infrastructure. Previously
                    CTO at two algorithmic trading companies, one of which he co-founded, and CEO at
                    a startup building cloud-based data infrastructure for IoT.
                </>
            ),
            email: 'henri.pihkala@streamr.com',
            id: 'henriPihkala',
            linkedin: 'https://www.linkedin.com/in/henripihkala',
            name: 'Henri Pihkala',
            role: 'Co-founder, Chief Scientist',
            twitter: 'https://twitter.com/henripihkala',
        },
        {
            description: (
                <>
                    Matthew is a serial technical co-founder and crypto-native engineer. Over the
                    past six years, he&apos;s been at the forefront of building the Streamr Network
                    ecosystem, serving as its project lead and CEO.
                </>
            ),
            id: 'matthewFontana',
            name: 'Matthew Fontana',
            role: 'CEO',
        },
        {
            description: (
                <>
                    With Streamr since 2015, Eric is a developer with eight years of industry
                    experience and a maths-oriented education in computer science. He is interested
                    in software architecture, machine learning, algorithms, and clean code and
                    previously worked on Alma Media&apos;s digital news operations for
                    half-a-decade.
                </>
            ),
            id: 'ericAndrews',
            linkedin: 'https://www.linkedin.com/in/eric-andrews-2aa00345/',
            name: 'Eric Andrews',
            role: 'CTO',
        },
        {
            description: (
                <>
                    Seasoned executive with a breadth of commercial experience from start-ups to
                    international corporates. Strong team leader with excellent communication
                    skills, sound strategic thinking and a commitment to delivery. Strong track
                    record while developing & maintaining positive team, customer & stakeholder
                    relationships.
                </>
            ),
            id: 'markLittle',
            name: 'Mark Little',
            role: 'Chief Commercial Officer',
        },
        {
            description: (
                <>
                    Serial entrepreneur and outside-the-box thinker with several successful exits.
                    Among his successes is Quartal, with Quartal Flife sold to Investis Ltd (UK),
                    Quartal Financial Solutions acquired by KMU Capital AG, and Quartal Content
                    Management bought by Satama Plc.
                </>
            ),
            email: 'nikke.nylund@streamr.com',
            id: 'nikkeNylund',
            linkedin: 'https://www.linkedin.com/in/nikkenylund/',
            name: 'Nikke Nylund',
            role: 'Co-founder',
            twitter: 'https://twitter.com/NikkeNylund',
        },
        {
            description: (
                <>
                    Santeri is a software developer with interests in Distributed systems and Data
                    science. He holds an MSc in computer science with a focus on networking. He
                    joined the team in 2018 with an interest in P2P systems and did his
                    master&apos;s thesis on the Streamr Network&apos;s P2P overlays. Plan B; become
                    a rock star/street musician.
                </>
            ),
            id: 'santeriJuslenius',
            name: 'Santeri Juslenius',
            role: 'Lead Developer',
        },
        {
            description: (
                <>
                    &ldquo;A comfort zone is a beautiful place but nothing ever grows there.&rdquo;
                    ― Unknown Author
                </>
            ),
            id: 'petriSavolainen',
            name: 'Petri Savolainen',
            role: 'P2P Researcher',
        },
        {
            description: (
                <>
                    Teo is a full-stack developer and software architect. He has strong work
                    experience since the beginning of the millennium. Previously he has built data
                    analysis solutions e.g. for the finance industry. He prefers simple and
                    straightforward solutions which are easily maintained.
                </>
            ),
            id: 'teoGebhard',
            name: 'Teo Gebhard',
            role: 'Senior Developer',
        },
        {
            description: (
                <>
                    A native from Hanoi, Vietnam, Min has over a decade of experience in design and
                    production of online services and mobile applications. He is currently working
                    as a Design Lead at Helsinki based digital agency, Sangre. His designs are
                    embodied by finding the best balance between the emotional and the rational,
                    between the aesthetic and the functional. He believes unequivocally that a
                    well-minded design will make things better; better for people, better for
                    business and better for our planet.
                </>
            ),
            id: 'minhNguyen',
            name: 'Minh Nguyen',
            role: 'Lead Designer',
        },
        {
            description: (
                <>
                    Juuso is a full-stack developer and all-around software engineer. He&apos;s
                    worked full time on Ethereum applications since 2016. His interests include
                    recreational mathematics, the game of go (weiqi), blockchain wizardry, and
                    language learning.
                </>
            ),
            id: 'juusoTakalainen',
            linkedin: 'https://www.linkedin.com/in/jtakalainen/',
            name: 'Juuso Takalainen',
            role: 'Senior Developer',
            twitter: 'https://twitter.com/juuso_streamr',
        },
        {
            description: (
                <>
                    Mariusz is a passion-driven professional with 10+ years of commercial-grade
                    experience in web application development processes. Scrupulously
                    detail-oriented, dedicated to executing well-crafted&nbsp;UX.
                </>
            ),
            id: 'mariuszRolinski',
            name: 'Mariusz Roliński',
            role: 'Senior Developer',
            website: 'https://www.mariusz.io/',
        },
        {
            description: (
                <>
                    Tuomas is a well-seasoned software professional with lots of experience in
                    building applications and digital products for small and big companies. M.Sc. in
                    Software Engineering and a passion for finding simple solutions to complex
                    problems.
                </>
            ),
            id: 'tuomasKoponen',
            linkedin: 'https://www.linkedin.com/in/tkoponen/',
            name: 'Tuomas Koponen',
            role: 'Senior Developer',
        },
        {
            description: (
                <>
                    With a background in computer science and technical experience as a developer,
                    Nico brings a strong developer mindset to business development and partnerships
                    at Streamr. Previously, Nico worked in developer relations for Streamr, building
                    bridges between technology and community. Nico works from all over the world and
                    frequently travels to crypto conferences, staying at the forefront of
                    decentralized innovation and industry trends.
                </>
            ),
            id: 'nicoBurkart',
            name: 'Nico Burkart',
            role: 'Business Development & Partnerships',
        },
        {
            description: (
                <>
                    Julieta spent several years in sales and marketing, working for diverse
                    companies in the public sector in Mexico. Before starting with Streamr in 2018,
                    she had a practise as a private language teacher, and was also employed by
                    ARBIS, in the adult education sector in Finland. She studied Spanish Philology
                    at the University of Puebla, Mexico and a programme in Business and
                    Administration in Finland.
                </>
            ),
            id: 'julietaArenasMoran',
            name: 'Julieta Arenas Morán',
            role: 'Office Operations Manager',
        },
        {
            description: (
                <>
                    Tom has worked with various projects across the tech, communication, and Web3
                    sectors. He has managed the Streamr community and all things content and social
                    media since 2018.
                </>
            ),
            email: 'tom.hamilton@streamr.com',
            id: 'tomHamilton',
            linkedin: 'https://www.linkedin.com/in/tommhamilton/',
            name: 'Tom Hamilton',
            role: 'Head of Community and Content',
        },
        {
            description: (
                <>
                    Engineer and Jack of all trades. When not experimenting or advocating for
                    innovative Streamr use cases, he explores media streaming possibilities and
                    works on securing R&D grants for innovative projects leveraging Streamr tech.
                </>
            ),
            id: 'jarnoMarttila',
            name: 'Jarno Marttila',
            role: 'DevRel',
        },
    ],
}

const UnstyledTeam = ({ className }) => (
    <section className={className} id="team">
        <TeamContainer key={team.id} team={team} />
    </section>
)

const Team = styled(UnstyledTeam)`
    background-color: #f8f8f8;
    color: #13013d;
    overflow-x: hidden;
    padding: 0;
`

export default Team
